import { useNavigate } from '@tanstack/react-router';
import { FileText } from 'lucide-react';
import Table from '@/components/table/components/Table.tsx';
import ActionButton from '@/components/buttons/ActionButton.tsx';
import { messagesApiQueryKeys } from '@/features/dashboard/messages/api/messagesApi.queryKeys.ts';
import messagesApi from '@/features/dashboard/messages/api/messagesApi.ts';
import useMessageRowActions from '@/features/dashboard/messages/hooks/useMessageRowActions.ts';
import { messagesRoute } from '@/features/dashboard/messages/routes/messagesRoute.ts';
import { SettingsTab } from '@/features/dashboard/companySettings/routes/settingsRoute.ts';

const MessagesTable = () => {
  const navigate = useNavigate();
  const search = messagesRoute.useSearch();
  const rowContextMenuItems = useMessageRowActions();

  return (
    <Table
      listSearch={search}
      queryKey={messagesApiQueryKeys.all()}
      fetchData={messagesApi.getMessages}
      fetchTableDef={messagesApi.getTableDefinition}
      rowContextMenuItems={rowContextMenuItems}
      title="Wiadomości"
      primaryAction={
        <ActionButton
          tone="outline"
          size="sm"
          onClick={() =>
            navigate({
              to: '/app/company-settings',
              search: { tab: SettingsTab.EMAIL_TEMPLATES },
            })
          }
        >
          <FileText />
          Szablony wiadomości
        </ActionButton>
      }
    />
  );
};

export default MessagesTable;
